<template>
  <v-row>
    <v-col
      cols="12"
      class="pa-0"
      v-for="(type, index) in dictionaries.addressType"
      :key="index"
    >
      <v-col
        v-for="(item, i) in filteredAddresses(type)"
        :key="i"
      >
        <AddressesComponent
          :address="item"
          @save-address="saveAddresses($event, item)"
        />
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
import Title from '@/components/ui/Title'
import AddressesComponent from '@/components/zvp/personal-data/address-gar/Addresses'
import {mapGetters} from 'vuex'
import {AddressGarParent, AddressGar} from '@/models'
import _ from 'lodash'

export default {
  name: "AddressGar",

  components: {
    Title,
    AddressesComponent
  },

  props: {
    addressGarParent: AddressGarParent,
  },

  data: () => ({
    localAddressGarParent: new AddressGarParent(),
  }),

  computed: {
    ...mapGetters('dictionaries', ['dictionaries']),
  },

  methods: {
    filteredAddresses(type) {
      if (!this.localAddressGarParent.list?.some(el => el.addressType?.id === type?.id)) {
        this.addAddress(type)
      }
      return this.localAddressGarParent.list.filter(el => el.addressType?.id === type?.id)
    },

    addAddress(type) {
      const address = new AddressGar()
      address.addressType = type
      this.localAddressGarParent.list.push(address)
    },

    async saveAddresses(event, item) {
      item.setProperties(event)
      this.$emit('set-address-gar-parent', this.localAddressGarParent)
    },
  },

  watch: {
    addressGarParent: {
      immediate: true,
      deep: true,
      handler(value) {
        this.localAddressGarParent = _.cloneDeep(value)
      }
    },
  }
}
</script>

<style scoped>
</style>
